import { createAction, props } from '@ngrx/store';
import { TocItem } from '@mhe/reader/models';

export const tocItemSelected = createAction('ToC Item Selected', props<{ tocItem?: TocItem }>());

export const setActiveTocItem = createAction('Set Active ToC Item', props<{ tocItem: TocItem }>());

export type TocActions = ReturnType<typeof tocItemSelected | typeof setActiveTocItem>;
